import React from 'react';
import { motion } from 'framer-motion';
import { Wand2, Code2, Eye, Search, Copy, Video } from 'lucide-react';
const benefits = [{
  icon: Wand2,
  text: "Cómo transformar una frase simple en un anuncio cinematográfico premium — sin cámara, sin modelo, sin diseñador."
}, {
  icon: Code2,
  text: "La fórmula de prompts exacta que hace que la IA renderice como un estudio de $50,000 (copia, pega, listo)."
}, {
  icon: Eye,
  text: "Cómo detener el scroll en 3 segundos usando la psicología visual que los grandes anunciantes esconden."
}, {
  icon: Search,
  text: "Cómo espiar los anuncios ganadores de tu competencia y modelarlos con IA en minutos."
}, {
  icon: Copy,
  text: "Cómo generar 50 variaciones de un mismo anuncio en una tarde — con $0 en producción."
}, {
  icon: Video,
  text: "Cómo animar tus imágenes y convertirlas en video cinematográfico que parece rodado en cine."
}];
export function Benefits() {
  return <section className="py-12 md:py-24 bg-zinc-950 px-4" data-id="element-14" data-mp="2rfzbhqnbuna">
      <div className="max-w-5xl mx-auto" data-id="element-15" data-mp="2pwjttctdnmk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-16" data-mp="6tazuk0r6400">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-17" data-mp="3twzbsn0h7xxu">
            Esto No Es "Otro Curso". Es Una <span className="text-amber-500" data-id="element-18" data-mp="lhfk3sfgenkw">Máquina de Imprimir Anuncios</span> Que Cabe en Tu Laptop
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-19" data-mp="qfz961pcgfhh">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 rounded-2xl bg-zinc-900 border border-zinc-800 hover:border-amber-500/50 transition-all duration-500 hover:shadow-[0_0_30px_rgba(245,158,11,0.1)] group relative overflow-hidden" data-id="element-20" data-mp="bq1ovwujc9xk" data-mpi={index}>
              {/* Subtle background gradient on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-21" data-mp="194sx8nv6sz3n" />

              <div className="relative mb-6 inline-block" data-id="element-22" data-mp="1044ljzt9natx">
                {/* Glow effect behind icon */}
                <div className="absolute inset-0 bg-amber-500/0 group-hover:bg-amber-500/30 blur-xl rounded-full transition-all duration-500" data-id="element-23" data-mp="vd5zskpidkja" />

                <motion.div animate={{
              y: [0, -5, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
              delay: index * 0.2
            }} className="relative w-14 h-14 rounded-xl bg-zinc-800/80 flex items-center justify-center border border-zinc-700 group-hover:border-amber-500/50 group-hover:bg-amber-500/10 transition-all duration-500 z-10" data-id="element-24" data-mp="qeurieev3i36">
                  <benefit.icon className="w-7 h-7 text-zinc-400 group-hover:text-amber-400 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500 group-hover:drop-shadow-[0_0_12px_rgba(245,158,11,0.8)]" data-id="element-25" data-mp="2o4i084ptk0yh" />
                </motion.div>
              </div>
              
              <p className="text-zinc-300 leading-relaxed relative z-10" data-id="element-26" data-mp="31zu7tcp2plwt">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}